<div class="container">
    <div class="single-column-layout manage-api-keys">
        <h1>API Keys</h1>
        <div [style.display]="loading ? 'block' : 'none'" class="text-center" style="margin-top: 50px;">
            <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
        </div>
        @if (!loading) {
            <div>
                <div [style.display]="addingKey ? 'none' : 'block'">
                    <button class="ace-btn btn-primary" type="button" (click)="addNewKey()">Add New Key</button>
                    <table class="table table-striped table-hover table-condensed">
                        <thead>
                            <tr>
                                <th>Public Key</th>
                                <th>Name</th>
                                <th>Company</th>
                                <th>Active</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (apiKey of apiKeys; track identify(apiKey)) {
                                <tr
                                    style="cursor:pointer;"
                                    [style.color]="apiKey.isActive ? 'black' : '#a0a0a0'"
                                    (click)="goToDetail(apiKey.integrationHmacId)">
                                    <td>{{ apiKey.publicKey }}</td>
                                    <td>{{ apiKey.name }}</td>
                                    <td>{{ apiKey.companyName }}</td>
                                    @if (apiKey.isActive) {
                                        <td>Yes</td>
                                    }
                                    @if (!apiKey.isActive) {
                                        <td>No</td>
                                    }
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
                <div [style.display]="addingKey ? 'block' : 'none'" class="new-key">
                    <label>
                        <span class="label-text">Name:</span>
                        <input type="text" class="form-input" [(ngModel)]="newKeyName"/>
                        @if (newKeyNameValidationMessage) {
                            <span class="validation-error">{{ newKeyNameValidationMessage }}</span>
                        }
                    </label>
                    <label>
                        <span class="label-text">Company:</span>
                        <span class="form-input">
                            <company-picker [topLevelOnly]="true"
                                            (companySelected)="companySelected($event)"></company-picker>
                        </span>
                        @if (newCompanyValidationMessage) {
                            <span class="validation-error">{{ newCompanyValidationMessage }}</span>
                        }
                    </label>
                    <div class="my-3">
                        <button class="ace-btn btn-primary" type="button" (click)="saveKey()">Save</button>
                        <button class="ace-btn btn-secondary ms-2" type="button" (click)="cancelAddKey()">Cancel
                        </button>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
